import { render } from "./InfoBlock.vue?vue&type=template&id=96f073f8&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"

import "./InfoBlock.vue?vue&type=style&index=0&id=96f073f8&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f073f8"]])

export default __exports__